import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import dayjs, { Dayjs } from 'dayjs'
import { MonthCascaderField } from '@/components/molecules/month-cascader-field'
import { getReservationsBoundaryDates } from '@/apis/aipass'

type Props = {
  value: Dayjs
  onChange: (month: Dayjs) => void
}

export const MonthSelector: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation()
  const [selectedMonth, setSelectedMonth] = useState<Dayjs>(value)
  const [reservationsBoundaryDates, setReservationsBoundaryDates] = useState<{ min: string; max: string }>()

  const moveMonth = (delta: number) => {
    setSelectedMonth(selectedMonth.clone().add(delta, 'month'))
  }

  useEffect(() => {
    if (!selectedMonth) {
      return
    }
    onChange(selectedMonth)
  }, [selectedMonth])

  useEffect(() => {
    getReservationsBoundaryDates().then(res => setReservationsBoundaryDates(res))
  }, [])

  return (
    <div css={dateBlockStyle}>
      <div className="prev" onClick={() => moveMonth(-1)}>
        <img src={require('@/static/images/arrow_right_gray_nospace.svg')} />
        <span>{t('Previous month')}</span>
      </div>
      <MonthCascaderField
        value={selectedMonth}
        onChange={setSelectedMonth}
        min={reservationsBoundaryDates?.min}
        max={reservationsBoundaryDates?.max}
        width="112px"
      />
      <div className="next" onClick={() => moveMonth(1)}>
        <span>{t('Next month')}</span>
        <img src={require('@/static/images/arrow_right_gray_nospace.svg')} />
      </div>
    </div>
  )
}

const dateBlockStyle = css({
  display: 'flex',
  alignItems: 'center',
  color: '#A3A3A3',
  '.prev, .next': {
    display: 'flex',
    alignItems: 'center',
    span: { padding: '0 8px' },
    img: { height: 14 },
    cursor: 'pointer',
  },
  '.prev': {
    span: { paddingRight: 16 },
    img: { transform: 'rotate(180deg)' },
  },
  '.next': {
    span: { paddingLeft: 16 },
  },
})
